<script setup lang="ts">
import { ref } from 'vue'

import MobileSearchInputBar from '@/components/map/MobileSearchInputBar.vue'
import SmartSearchResultsSheet from '@/components/map/SmartSearchResultsSheet.vue'
import { useSmartSearch } from '@/composables/useSmartSearch'

defineOptions({ name: 'MobileSearchSurface' })

// Mobile search surface (MapOut-style): owns the single useSmartSearch() instance and composes
// the pinned top input bar + the draggable bottom results drawer, so the input and results are
// separate and the map stays visible between them. Only mounted on mobile while search is open;
// the desktop pill (MapSmartSearch) keeps its own instance and is untouched.
const search = useSmartSearch()

const inputFocused = ref(false)
</script>

<template>
  <div>
    <MobileSearchInputBar
      :search="search"
      @focus="inputFocused = true"
      @blur="inputFocused = false"
    />
    <SmartSearchResultsSheet :search="search" :input-focused="inputFocused" />
  </div>
</template>
